import { IntlShape } from 'react-intl';
import { PodiumAccessType, TPodiumAccessTypeLabel } from '../../../../../../api/podium.dao';
import { Container } from 'typescript-ioc';
import { IReactIntlProvider } from '../../../../../../infrastructure/react-intl-provider';

export const PODIUM_ENABLE_TEXT = {
  id: 'podium.enable',
  message: 'Podium is {suffix}',
  description: 'Enable Podium',
};

export const PODIUM_LINK_TEXT = {
  id: 'podium.link',
  defaultMessage: 'Podium Link',
  description: 'Podium link',
};

export const PRESENTER_VIEW_ENABLE_TEXT = {
  id: 'podium.presenterView.enable',
  message: 'Presenter View is {suffix}',
  description: 'Enable Podium Presenter View',
};

export const PRESENTER_VIEW_LINK_TEXT = {
  id: 'podium.presenterView.link',
  defaultMessage: 'Presenter View Link',
  description: 'Podium Presenter View link',
};

export const CONTROL_SLIDES_LINK_TEXT = {
    id: 'podium.ControlSlidesLink',
    defaultMessage: 'One-Click Podium 1.0 Link (Control Slides Link)',
    description: 'Control Slides Link',
};

export const PODIUM_ACCESS_TYPE_TEXT = {
  id: 'oe.podium.accessType',
  defaultMessage: 'Access Type',
  description: 'Access Type',
};

export const PODIUM_FEATURES_TEXT = {
    id: 'oe.podium.features',
    defaultMessage: 'Features',
    description: 'Features',
};

export const CONTROL_SLIDES_LABEL = {
    id: 'oe.podium.ControlSlides',
    defaultMessage: 'Control Slides',
    description: 'Control Slides',
};

export const PODIUM_QUESTION_ANSWER_LABEL = {
    id: 'oe.podium.QuestionAnswer',
    defaultMessage: 'Q&A',
    description: 'Q&A',
};

export const PODIUM_PARTICIPANTS_LABEL = {
    id: 'oe.podium.Participants',
    defaultMessage: 'Participants',
    description: 'label',
};

export const PODIUM_ATTENDEES_LABEL = {
    id: 'oe.podium.Attendees',
    defaultMessage: 'Attendees',
    description: 'label',
};

export const DISCONNECT_ATTENDEES_LABEL = {
    id: 'oe.podium.disconnectAttendees',
    defaultMessage: 'Disconnect Attendees',
    description: 'label',
};

export const DEFAULT_PARTICIPANTS_LABEL = 'Participants';

export const PARTICIPANTS_TAB_LABEL_TEXT = {
    id: 'oe.podium.participantsTabLabel',
    defaultMessage: 'Participants tab label',
    description: 'Label for the participants tab label input',
};

export const PARTICIPANTS_SECTION_LABEL_REQUIRED_ERROR = {
    id: 'oe.podium.participantsSectionLabel.required',
    defaultMessage: 'Section label is mandatory',
    description: 'Participants section label required error',
};


export const PODIUM_CHAT_LABEL = {
    id: 'oe.podium.chat',
    defaultMessage: 'Chat',
    description: 'label',
};

const OE_CENTRAL_SIGN_IN_ACCESS_TYPE = {
  id: 'oe.podium.accessType.oeCentralSignIn',
  defaultMessage: 'Sign In with OE Central (Default)',
  description: 'Option label',
};

const OPEN_REGISTRATION_ACCESS_TYPE = {
  id: 'oe.podium.accessType.openRegistration',
  defaultMessage: 'Open Registration',
  description: 'Option label',
};

export const getPodiumAccess = (intl: IntlShape): TPodiumAccessTypeLabel[] => {
  return [
    {
      value: PodiumAccessType.oeCentralSignIn,
      label: intl.formatMessage(OE_CENTRAL_SIGN_IN_ACCESS_TYPE),
    },
    {
      value: PodiumAccessType.openRegistration,
      label: intl.formatMessage(OPEN_REGISTRATION_ACCESS_TYPE)
    }
  ];
};

export const QUESTIONS_AUDIT_LOG_DOWNLOAD_NOTIFICATION = {
    id: 'oe.podium.downloadedQuestionsAuditLog',
    defaultMessage: 'Questions Audit Log download has started'
};

export const getPodiumAccessType = (type: PodiumAccessType): string => {
  const reactIntlProvider = Container.get(IReactIntlProvider).getIntl();
  const accessType = getPodiumAccess(reactIntlProvider).find(t => {
    return t.value === type;
  });
  return accessType.label;
};

export const PODIUM_PARTICIPANTS_INFO_MESSAGE = {
    id: 'oe.podium.participants.infoMessage',
    description: 'Checkbox label',
    defaultMessage: 'The Participants tab in Podium will display attendees who have joined by Zoom Meeting or Zoom Webinar. The Participants list can be used to see and manage raised hands for verbal questions.',
};

export const PODIUM_ATTENDEES_INFO_MESSAGE = {
    id: 'oe.podium.attendees.infoMessage',
    description: 'Checkbox label',
    defaultMessage: 'The Attendees tab will display attendees who have joined by any live-monitored method; OE Stream, Zoom Meeting or Zoom Webinar.',
};